import React from "react";
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
} from "@mui/material";
import libFloat from "../../../../util/libFloat";
import { formatInTimeZone } from "date-fns-tz";
import { RefreshCcw } from "lucide-react";

export function TableParcelasVenda({ parcelas, onRefazer }) {
	const formatCurrency = (val) => libFloat.strToCurrency(val || 0);

	return (
		<div className="mb-2">
			<div className="flex justify-between items-end mb-2">
				<h2 className="text-lg font-bold text-[#1e3a8a] uppercase tracking-wide">
					Parcelas
				</h2>
				<button 
					className="flex items-center gap-1 text-xs font-bold text-blue-600 hover:text-blue-800 transition-colors uppercase"
					title="Refazer Parcelas"
					onClick={onRefazer}
				>
					<RefreshCcw size={14} /> Refazer Parcelas
				</button>
			</div>
			
			<TableContainer component={Paper} className="shadow-none border border-gray-200 rounded-none">
				<Table size="small">
					<TableHead className="color-table">
						<TableRow>
							<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Parcela</TableCell>
							<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Vencimento</TableCell>
							<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Forma Pgto</TableCell>
							<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Status</TableCell>
							<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Dt. Pagamento</TableCell>
							<TableCell align="right" style={{ color: "#fff", fontWeight: "bold" }}>Valor</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{parcelas?.length > 0 ? (
							parcelas.map((parcela, index) => {
                                const isPending = parcela.ativo === "SIM" || parcela.ativo === true || parcela.ativo === 1;
								return (
									<TableRow key={index} hover>
										<TableCell>
											{parcela.documento ||
												(parcela.parcela
													? `${parcela.parcela}/${parcela.parcela_total ?? parcelas.length}`
													: `${index + 1}/${parcelas.length}`)}
										</TableCell>
										<TableCell>
											{parcela.dataparcela ? formatInTimeZone(new Date(parcela.dataparcela), "UTC", "dd/MM/yyyy") : "—"}
										</TableCell>
										<TableCell>{parcela.forma || "—"}</TableCell>
										<TableCell style={{ color: isPending ? "#dc2626" : "#16a34a", fontWeight: "bold" }}>
											{isPending ? "Pendente" : "Pago"}
										</TableCell>
										<TableCell>
											{parcela.datapgto ? formatInTimeZone(new Date(parcela.datapgto), "UTC", "dd/MM/yyyy") : "—"}
										</TableCell>
										<TableCell align="right">
											{formatCurrency(parcela.valor || 0)}
										</TableCell>
									</TableRow>
								);
							})
						) : (
							<TableRow>
								<TableCell colSpan={6} align="center" style={{ padding: "20px", color: "#6b7280" }}>
									Nenhuma parcela encontrada.
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
}
